import { CardSize } from '../../../../utils/type'
import { CSSProperties, ReactNode, useMemo, useState } from 'react'
import { XImage } from '../XImage'
import styled, { css } from 'styled-components'
import { commonStyles } from '../../../../utils/commonStyles'
import { Images } from '../../../../utils/images'
import { sizeMap } from './common'
import { useRequest } from 'ahooks'
import { fetchText } from '../../../../utils'

export function CardRecursive(props: {
  content_uri: string
  size: CardSize
  children?: ReactNode
  className?: string
  style?: CSSProperties
}) {
  // const [imgLoading, setImageLoading] = useState(true)
  const [isError, setIsError] = useState(false)
  const { data, loading, error } = useRequest(() => fetchText(props.content_uri), {
    cacheKey: props.content_uri,
    refreshDeps: [props.content_uri],
  })
  const svgText = useMemo(() => {
    //从props.content_uri里面提取链接的跟路径
    const origin = props.content_uri.match(/(https?:\/\/[^\/]+)\//)?.[1] || ''

    if (!data) return ''
    return data
      .replace(/href\=\"\/\-\//g, 'href="/')
      .replace(/\/\:/g, '/')
      .replace(/href\=\"\//g, `href="${origin}/`)
  }, [data])
  if (error) {
    setIsError(true)
  }
  const isLoading = loading
  return (
    <CardWrapper
      className={props.className}
      style={props.style}
      isLoading={isLoading}
      size={props.size}
      isError={isError}
    >
      {!isError && !!data && <SVGContainer dangerouslySetInnerHTML={{ __html: svgText }} />}
      {isError && (
        <>
          <ErrorIcon size={props.size} />
          <ErrorText size={props.size}>Content not available yet</ErrorText>
        </>
      )}
      {props.children}
    </CardWrapper>
  )
}

const SVGContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

const CardWrapper = styled.div<{ isLoading?: boolean; size: CardSize; isError?: boolean }>`
  ${(props) =>
    props.size === CardSize.Medium
      ? css`
          width: 100%;
          aspect-ratio: ${sizeMap[props.size].width} / ${sizeMap[props.size].height};
        `
      : css`
          height: ${sizeMap[props.size].height}px;
          width: ${sizeMap[props.size].width}px;
        `}
  position: relative;
  overflow: hidden;
  ${(props) => (props.isLoading ? commonStyles.skeleton : '')};
  ${commonStyles.flexCenter};
  flex-direction: column;
  background-color: ${(props) => (props.isError ? '#231f20' : 'transparent')};
  iframe.cover {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: all 0.4s linear;
    border: none;
  }
`

const iconSizeMap: { [key in CardSize]: number } = {
  [CardSize.Small]: 30,
  [CardSize.Medium]: 42,
  [CardSize.Large]: 60,
}

const ErrorIcon = styled(XImage).attrs({
  src: Images.COMMON.UNAVAILABLE_SVG,
})<{ size: CardSize }>`
  width: ${(props) => iconSizeMap[props.size]}px;
  height: ${(props) => iconSizeMap[props.size]}px;
`

const ErrorText = styled.p<{ size: CardSize }>`
  font-size: ${(props) => (props.size === CardSize.Large ? '16px' : '12px')};
  margin-top: 10px;
  color: #9e9e9e;
  text-align: center;
`
